import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { CategoryFilterTreeItem } from '../../../../../../Model/Catalog/exportFilter/categoryFilterTreeItem';
import { TreeItem } from '../../../../../../Model/Dto/TreeItem';
import { CatalogFilter } from '../../../../../../Model/exportParameter/CatalogFilter';
import { ExportParameter } from '../../../../../../Model/exportParameter/ExportParameter';
import { SimpleHierachicalFilter } from '../../../../../../Model/exportParameter/SimpleHierachicalFilter';
import { ExportFilterService } from '../../../../../../Services/exportFilter.service';
import { ModelService } from '../../../../../../Services/model.service';

@Component({
  selector: 'mime-filter',
  templateUrl: './mime-filter.component.html'
})
export class MimeFilterComponent implements OnInit {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView: DxTreeViewComponent;
  @Input() exportParameter: ExportParameter;
  @Input() catalogId: string;
  @Input() customerId: string;

  mimeSelectFilters: { description: string }[] = [];
  isFilterLoaded: boolean = false;


  constructor(public modelService: ModelService, public translate: TranslateService, public exportFilterService: ExportFilterService) {
    this.refreshMimeSelectFilter = this.refreshMimeSelectFilter.bind(this);
  }

  ngOnInit(): void {
    if (this.exportParameter.mimeFilter == null)
      this.exportParameter.mimeFilter = new CatalogFilter<string[]>([])
    if (this.exportParameter.mimeFilter.filterKey == null)
      this.exportParameter.mimeFilter.filterKey = [];

    this.refreshMimeSelectFilter();
  }

  refreshMimeSelectFilter() {
    this.isFilterLoaded = false;
    this.exportFilterService.getMimeFilterTreeElements(this.catalogId, this.customerId)
      .subscribe((filter: string[]) => {
        this.mimeSelectFilters = filter.map(description => ({ description }));
        this.isFilterLoaded = true;
        });
  }
}
